import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M6.667 13.333C5.747 13.333 5 14.08 5 15v18.333C5 34.253 5.746 35 6.667 35h26.666c.92 0 1.667-.746 1.667-1.667V15c0-.92-.746-1.667-1.667-1.667H6.667Zm-5 1.667a5 5 0 0 1 5-5h26.666a5 5 0 0 1 5 5v18.333a5 5 0 0 1-5 5H6.667a5 5 0 0 1-5-5V15Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M10.488 2.154a1.668 1.668 0 0 1 2.357 0L20 9.31l7.155-7.155a1.667 1.667 0 1 1 2.357 2.357l-8.334 8.334c-.65.65-1.706.65-2.357 0L10.489 4.51a1.667 1.667 0 0 1 0-2.357Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }